import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import { Button, Modal } from 'react-bootstrap';
import { FaEye, FaHeart, FaTimesCircle, FaArrowLeft, FaNewspaper, FaArrowRight, FaArrowCircleLeft, FaArrowCircleRight, FaChevronDown, FaChevronUp, FaEdit } from 'react-icons/fa';
import { BsStopwatch } from 'react-icons/bs';
import Navbar from '../dashboard/navbar';
import { useLocation, useNavigate } from 'react-router-dom';
import Sidebar from '../dashboard/sidebar';
import useAuth from '../dashboard/useAuth';
import axios from 'axios';
import useVerifInternet from '../administration/verifInternet';
import StatutInternet from '../administration/statutInternet';
import QuestionModal from '../administration/qcm/editeur_qcm';

const Demarrer_examen = () => {
    useAuth(); // Vérifie l'authentification
    const location = useLocation();
    const enLigne = useVerifInternet();
    const navigate = useNavigate();
    const [isPaused, setIsPaused] = useState(false);

    // États
    const [qcms, setQcms] = useState([]);
    const [langue, setLangue] = useState('');
    const [alert, setAlert] = useState({ message: '', type: '' });
    const [answers, setAnswers] = useState({});
    const [favorites, setFavorites] = useState(new Set());
    const [currentQcmIndex, setCurrentQcmIndex] = useState(() => {
        const savedIndex = localStorage.getItem("currentQcmIndex");
        return savedIndex !== null ? Number(savedIndex) : 0; // Si existe, on le prend, sinon 0
    });

    const [selectedAnswer, setSelectedAnswer] = useState(null);
    const [explanationVisible, setExplanationVisible] = useState(false);
    const [feedbackVisible, setFeedbackVisible] = useState(false);
    const [isAnswerCorrect, setIsAnswerCorrect] = useState(null);
    const user_id = localStorage.getItem('user_id');
    const { examen_id, nbre_heures, statut, type_examen } = location.state || {};

    const isEssai = type_examen === 'Essai';

    const { pauseChoice } = location.state || {};
    const [afficherAide, setAfficherAide] = useState(false);
    const [showInfo, setShowInfo] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    const [showPauseModal, setShowPauseModal] = useState(false);
    const [showConfirmationModal, setShowConfirmationModal] = useState(false);
    const handleShowPauseModal = () => setShowPauseModal(true);
    const handleClosePauseModal = () => setShowPauseModal(false);

    // Gestion du chronomètre
    const heureDebutInitiale = () => {
        if (isEssai) return null;
        const debut = new Date().toISOString(); // Stocker en format ISO
        localStorage.setItem('heureDebutExamen', debut);
        return debut;
    };

    // Initialisation de l'état pour l'heure de début
    const [heureDebut, setHeureDebut] = useState(() => {
        return localStorage.getItem('heureDebutExamen') || heureDebutInitiale();
    });

    const heureFinInitiale = () => {
        if (isEssai) return null;
        const fin = new Date();
        fin.setSeconds(fin.getSeconds() + nbre_heures * 3600);
        return fin.getTime();
    };

    // Initialisation de l'état avec conversion en nombre
    const [heureFin, setHeureFin] = useState(() => {
        const stored = localStorage.getItem('heureFinExamen');
        return stored ? Number(stored) : heureFinInitiale();
    });

    const [remainingTime, setRemainingTime] = useState(
        Math.max(0, Math.floor((heureFin - Date.now()) / 1000))
    );

    // Gestion de la pause
    const [pauseStartTime, setPauseStartTime] = useState(null); // Heure de début de la pause
    const [totalPausedTime, setTotalPausedTime] = useState(0); // Temps total de pause en millisecondes
    const [pauseRemainingTime, setPauseRemainingTime] = useState(null); // Temps restant de la pause

    // Sauvegarde et mise à jour du chronomètre
    useEffect(() => {
        localStorage.setItem('heureFinExamen', heureFin);
    }, [heureFin]);

    const timerRef = useRef(null);

    // useEffect(() => {
    //     const startTimeKey = "examStartTime";
    //     const savedStartTime = localStorage.getItem(startTimeKey);
    //     const startTime = savedStartTime ? parseInt(savedStartTime, 10) : Date.now();

    //     if (!savedStartTime) {
    //         localStorage.setItem(startTimeKey, startTime);
    //     }

    //     const totalTimeInSeconds = nbre_heures * 60 * 60;
    //     const oneThirdTimeInSeconds = totalTimeInSeconds / 3;

    //     const updateTimer = () => {
    //         if (isPaused) {
    //             return; // Ne pas mettre à jour le temps pendant la pause
    //         }

    //         const elapsedTime = Math.floor((Date.now() - startTime - totalPausedTime) / 1000);
    //         const remaining = Math.max(totalTimeInSeconds - elapsedTime, 0);

    //         if (remaining <= 0) {
    //             clearInterval(timerRef.current);
    //             handleFinishExamen();
    //         }

    //         setRemainingTime(remaining);

    //         // Afficher la modal de pause à chaque tier du temps
    //         if (elapsedTime % oneThirdTimeInSeconds === 0 && elapsedTime !== 0) {
    //             handleShowPauseModal(); // Afficher le modal de pause
    //         }
    //     };

    //     if (!isPaused) {
    //         updateTimer();
    //         timerRef.current = setInterval(updateTimer, 1000);
    //     }

    //     return () => {
    //         clearInterval(timerRef.current);
    //     };
    // }, [isPaused, totalPausedTime]);

    // Gérer la pause
    // const togglePause = () => {
    //     setIsPaused((prev) => {
    //         const newPausedState = !prev;

    //         if (newPausedState) {
    //             // Début de la pause
    //             const pauseStart = Date.now();
    //             setPauseStartTime(pauseStart);
    //             localStorage.setItem('pauseStartTime', pauseStart.toString());
    //             localStorage.setItem('isPaused', 'true');
    //         } else {
    //             // Fin de la pause
    //             if (pauseStartTime) {
    //                 const pauseDuration = Date.now() - pauseStartTime; // Durée réelle de la pause
    //                 const maxPauseDuration = 10 * 60 * 1000; // 10 minutes en millisecondes
    //                 const actualPauseDuration = Math.min(pauseDuration, maxPauseDuration); // Ne pas dépasser 10 minutes
    //                 setTotalPausedTime((prevTotal) => prevTotal + actualPauseDuration);
    //                 setPauseStartTime(null);
    //                 localStorage.removeItem('pauseStartTime');
    //                 localStorage.setItem('isPaused', 'false');
    //             }
    //         }

    //         return newPausedState;
    //     });
    // };




    const [showModal, setShowModal] = useState(false);

    const handleCloseModal = () => {
        setShowModal(false);
    };




    const [pausedAtTimes, setPausedAtTimes] = useState(new Set());
    useEffect(() => {
        if (isEssai) {
            setRemainingTime(null); // Pas de temps restant
            return;
        }
        const startTimeKey = "examStartTime";
        const savedStartTime = localStorage.getItem(startTimeKey);
        const startTime = savedStartTime ? parseInt(savedStartTime, 10) : Date.now();

        if (!savedStartTime) {
            localStorage.setItem(startTimeKey, startTime);
        }

        // const totalTimeInSeconds = nbre_heures * 60 * 60 + (pauseChoice === "avecPause" ? 20 * 60 : 0);
        const totalTimeInSeconds = nbre_heures * 60 * 60;
        const oneThirdTimeInSeconds = totalTimeInSeconds / 3;

        const updateTimer = () => {
            if (isPaused) return;

            // Calcul unifié basé sur heureFin
            const now = Date.now();
            const isExamOver = now >= heureFin;

            if (isExamOver) {
                clearInterval(timerRef.current);
                handleFinishExamen();
                return;
            }

            // Calcul du temps restant cohérent
            const newRemaining = Math.floor((heureFin - now) / 1000);
            setRemainingTime(newRemaining);

            // Gestion des pauses
            if (pauseChoice === "avecPause") {
                const elapsedActiveTime = Math.floor((now - startTime - totalPausedTime) / 1000);
                const oneThird = (nbre_heures * 3600) / 3;

                if (elapsedActiveTime > 0 &&
                    elapsedActiveTime % oneThird < 1 &&
                    !pausedAtTimes.has(Math.floor(elapsedActiveTime / oneThird))) {

                    handleShowPauseModal();
                    setPausedAtTimes(prev => new Set(prev).add(Math.floor(elapsedActiveTime / oneThird)));
                }
            }
        };

        if (!isPaused) {
            updateTimer();
            timerRef.current = setInterval(updateTimer, 1000);
        }

        return () => {
            clearInterval(timerRef.current);
        };
    }, [isPaused, totalPausedTime, pausedAtTimes, isEssai]);

    // const togglePause = () => {
    //     setIsPaused((prev) => {
    //         const newPausedState = !prev;

    //         if (newPausedState) {
    //             // Début de la pause
    //             const pauseStart = Date.now();
    //             setPauseStartTime(pauseStart);
    //             localStorage.setItem('pauseStartTime', pauseStart.toString());
    //             localStorage.setItem('isPaused', 'true');

    //             // Stocker le temps restant avant la pause
    //             localStorage.setItem('remainingTimeBeforePause', remainingTime.toString());
    //             navigate('/Recapitulatif-examen', {
    //                 state: { examen_id: examen_id, nbre_heures: nbre_heures, pauseChoice: pauseChoice },
    //             });
    //         } else {
    //             // Fin de la pause
    //             if (pauseStartTime) {
    //                 const pauseDuration = Date.now() - pauseStartTime; // Durée réelle de la pause
    //                 const maxPauseDuration = 10 * 60 * 1000; // 10 minutes en millisecondes
    //                 const actualPauseDuration = Math.min(pauseDuration, maxPauseDuration); // Ne pas dépasser 10 minutes

    //                 // Récupérer le temps restant avant la pause
    //                 const remainingTimeBeforePause = Number(localStorage.getItem('remainingTimeBeforePause'));

    //                 // Mettre à jour l'heure de fin en ajoutant la durée de la pause
    //                 // setHeureFin((prevHeureFin) => prevHeureFin + actualPauseDuration);

    //                 // Mettre à jour le temps total de pause
    //                 // setTotalPausedTime((prevTotal) => prevTotal + actualPauseDuration);

    //                 // Réinitialiser les états et le localStorage
    //                 setPauseStartTime(null);
    //                 localStorage.removeItem('pauseStartTime');
    //                 localStorage.removeItem('remainingTimeBeforePause');
    //                 localStorage.setItem('isPaused', 'false');
    //             }
    //         }

    //         return newPausedState;
    //     });
    // };


    const togglePause = () => {
        if (isEssai) return;

        setIsPaused(prev => {
            if (!prev) {
                // Début pause
                // setPauseStartTime(Date.now());
                // navigate('/Recapitulatif-examen', { state: { examen_id, nbre_heures, pauseChoice } });
                const pauseStart = Date.now();
                setPauseStartTime(pauseStart);
                localStorage.setItem('pauseStartTime', pauseStart.toString());
                localStorage.setItem('isPaused', 'true');

                // Stocker le temps restant avant la pause
                localStorage.setItem('remainingTimeBeforePause', remainingTime.toString());
                navigate('/Recapitulatif-examen', {
                    state: { examen_id: examen_id, nbre_heures: nbre_heures, pauseChoice: pauseChoice },
                });
            } else {
                // Fin pause
                const pauseEnd = Date.now();
                const pauseDuration = Math.min(pauseEnd - pauseStartTime, 10 * 60 * 1000);
                setTotalPausedTime(prev => prev + pauseDuration);
            }
            return !prev;
        });
    };

    // Restaurer l'état de la pause au chargement de la page
    useEffect(() => {
        const savedPauseStartTime = localStorage.getItem('pauseStartTime');
        const savedIsPaused = localStorage.getItem('isPaused');

        if (savedIsPaused === 'true' && savedPauseStartTime) {
            const pauseStart = Number(savedPauseStartTime);
            const pauseDuration = Date.now() - pauseStart;

            if (pauseDuration < 10 * 60 * 1000) {
                // Si la pause n'est pas terminée, reprendre la pause
                setIsPaused(true);
                setPauseStartTime(pauseStart);
                setPauseRemainingTime(10 * 60 * 1000 - pauseDuration);
            } else {
                // Si la pause est terminée, nettoyer le localStorage
                localStorage.removeItem('pauseStartTime');
                localStorage.setItem('isPaused', 'false');
            }
        }
    }, []);

    // Gérer le temps restant de la pause
    useEffect(() => {
        if (isPaused && pauseStartTime) {
            const intervalId = setInterval(() => {
                const pauseDuration = Date.now() - pauseStartTime;
                const remainingTime = Math.max(10 * 60 * 1000 - pauseDuration, 0);

                setPauseRemainingTime(remainingTime);

                if (remainingTime <= 0) {
                    // Si la pause est terminée, reprendre l'examen
                    togglePause();
                }
            }, 1000);

            return () => clearInterval(intervalId);
        }
    }, [isPaused, pauseStartTime]);

    // Fonction pour formater le temps
    const formatTime = (timeInSeconds) => {
        const hours = Math.floor(timeInSeconds / 3600);
        const minutes = Math.floor((timeInSeconds % 3600) / 60);
        const seconds = timeInSeconds % 60;
        return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
    };

    // Fonction pour formater une date en "HH:MM"
    const formatDateTime = (date) => {
        return date.toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit', second: '2-digit' });
    };

    // Récupérer l'heure de fin et la convertir en objet Date
    const examEndTime = heureFin ? new Date(heureFin) : null;

    // Convertir en objet Date
    const parseDate = (dateString, isISO) => {
        let date;
        if (isISO) {
            date = new Date(dateString); // Si c'est un format ISO
        } else {
            date = new Date(parseInt(dateString, 10)); // Convertir un timestamp millisecondes
        }
        return date.toLocaleString("fr-FR", {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit'
        }).replace(',', '');
    };

    // Gestion des réponses
    useEffect(() => {
        const savedAnswers = localStorage.getItem('answers');
        if (savedAnswers) {
            setAnswers(JSON.parse(savedAnswers));
        }
    }, []);

    const handleNextQcm = () => {
        if (currentQcmIndex < qcms.length - 1) {
            setCurrentQcmIndex(currentQcmIndex + 1);
            resetFeedbackState();
        }
    };

    const handlePreviousQcm = () => {
        if (currentQcmIndex > 0) {
            setCurrentQcmIndex(currentQcmIndex - 1);
            resetFeedbackState();
        }
    };

    const resetFeedbackState = () => {
        setExplanationVisible(false);
        setFeedbackVisible(false);
        setIsAnswerCorrect(null);
    };

    const [isLoadingBouton, setIsLoadingBouton] = useState(false);
    // Finalisation de l'examen
    const handleFinishExamen = async () => {
        setIsLoadingBouton(true);
        try {
            const savedAnswers = localStorage.getItem('answers');
            const answersToSend = savedAnswers ? JSON.parse(savedAnswers) : {};

            console.log("Réponses envoyées :", answersToSend);

            await fetch(`${process.env.REACT_APP_HOTE}/sauvegarder-reponse-qcm/`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    answers: answersToSend,
                    user_id: user_id,
                    nbre_heures: nbre_heures,
                    examen_id: examen_id,
                }),
            });

            await fetch(`${process.env.REACT_APP_HOTE}/resultats-examenblanc/`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    user_id: user_id,
                    examen_id: examen_id,
                }),
            });

            localStorage.removeItem('heureDebutExamen');
            localStorage.removeItem('heureFinExamen');
            localStorage.removeItem('answers');
            localStorage.removeItem('currentQcmIndex');
            localStorage.removeItem('examen_id_strored');
            localStorage.removeItem('answersRecap');
            localStorage.removeItem('isPaused');
            localStorage.removeItem('examStartTime');
            localStorage.removeItem('examPauseTime');
            localStorage.removeItem('totalPausedTime');
            localStorage.removeItem('pauseStartTime');
            localStorage.removeItem('totalPausedTime');
            localStorage.removeItem('remainingTimeBeforePause');

            navigate('/Resultat-examen', { state: { examen_id, user_id }, replace: true });
        } catch (error) {
            console.error('Erreur réseau:', error);
        } finally {
            setIsLoadingBouton(false);
        }
    };

    // Affichage d'alertes
    const showAlert = (message, type = 'success') => {
        setAlert({ message, type });
        setTimeout(() => setAlert({ message: '', type: '' }), 5000);
    };

    // Sauvegarder l'index actuel à chaque changement
    useEffect(() => {
        if (qcms.length > 0) {
            localStorage.setItem('currentQcmIndex', currentQcmIndex);
        }
    }, [currentQcmIndex, qcms]);

    const fetchExamens = async () => {
        setIsLoading(true);
        try {
            const heureDebutExamen = localStorage.getItem('heureDebutExamen');
            const heureFinExamen = localStorage.getItem('heureFinExamen');
            // if (!heureDebutExamen || !heureFinExamen) {
            //     showAlert("Erreur : Impossible de récupérer l\'heure de début ou de fin.", "danger");
            //     return;
            // }

            const isISODateDebut = isNaN(heureDebutExamen);
            const isISODateFin = isNaN(heureFinExamen);

            const heureDebutFormatee = parseDate(heureDebutExamen, isISODateDebut);
            const heureFinFormatee = parseDate(heureFinExamen, isISODateFin);

            // URL différente selon le type (essai ou examen normal)
            let url;
            if (isEssai) {
                url = `${process.env.REACT_APP_HOTE}/charger-qcms-essai/${user_id}/${examen_id}/`;
            } else {
                // Pour les examens normaux, garder l'ancienne URL avec les heures
                url = `${process.env.REACT_APP_HOTE}/charger-qcms-examenblanc/${user_id}/${nbre_heures}/${examen_id}/?heureDebut=${encodeURIComponent(heureDebutFormatee)}&heureFin=${encodeURIComponent(heureFinFormatee)}`;
            }

            const response = await fetch(url);
            const data = await response.json();
            if (response.ok) {
                setIsLoading(false);
                localStorage.setItem('examen_id_strored', examen_id);
                setQcms(data.qcms);
                setLangue(data.langue);

                const savedStep = localStorage.getItem('currentQcmIndex');
                if (savedStep) {
                    const step = Number(savedStep);
                    if (step >= 0 && step < data.qcms.length) {
                        setCurrentQcmIndex(step);
                    } else {
                        setCurrentQcmIndex(0);
                    }
                }
            } else {
                setIsLoading(false);
                showAlert('Erreur lors de la récupération des QCMs' + data.error, 'danger');
            }
        } catch (error) {
            setIsLoading(false);
            showAlert('Erreur réseau', 'error');
        }
    };

    useEffect(() => {
        fetchExamens();
    }, [user_id, examen_id]);

    const handleModifierLangue = async () => {
        const nouvelleLangue = langue === "Fr" ? "Ang" : "Fr";
        setLangue(nouvelleLangue);

        try {
            const response = await fetch(`${process.env.REACT_APP_HOTE}/modifier-langue-examenblanc/${examen_id}/${user_id}/`, {
                method: "PUT",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({ langue: nouvelleLangue })
            });

            const data = await response.json();
            if (response.ok) {
                fetchExamens();
            } else {
                const errorData = await response.json();
            }
        } catch (error) {
            console.error("Erreur lors de la requête :", error);
        }
    };




    // enreg reponse chaque seconde

    useEffect(() => {
        if (isEssai) return;
        if (!isPaused) {
            // Fonction asynchrone pour appeler l'API
            const fetchReponseChaqueCinqMin = async () => {
                try {
                    const savedAnswers = localStorage.getItem('answers');
                    const answersToSend = savedAnswers ? JSON.parse(savedAnswers) : {};

                    await fetch(`${process.env.REACT_APP_HOTE}/sauvegarder-reponse-qcm-chaque-cinq-min/`, {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/json' },
                        body: JSON.stringify({
                            answers: answersToSend,
                            user_id: user_id,
                            nbre_heures: nbre_heures,
                            examen_id: examen_id,
                        }),
                    });

                    // console.log('Réponse sauvegardée avec succès', answersToSend);
                } catch (error) {
                    console.error('Erreur lors de la sauvegarde des réponses:', error);
                }
            };

            // Appel initial immédiat de l'API
            fetchReponseChaqueCinqMin();

            // Appel API toutes les 5 minutes
            const intervalId = setInterval(fetchReponseChaqueCinqMin, 1000);

            // Nettoyage au démontage du composant
            return () => clearInterval(intervalId);
        }
    }, [!isPaused]);

    const [formattedAnswers, setFormattedAnswers] = useState(null);

    const handleMultipleAnswerChange = (qcmId, option, isChecked, currentQcmIndex) => {
        setAnswers(prevAnswers => {
            const isMultipleChoice = qcms.find(qcm => qcm.ref === qcmId)?.reponse.length > 1;

            let newAnswers;
            let newAnswersRecap;

            const previousAnswersRecap = JSON.parse(localStorage.getItem('answersRecap')) || {};

            if (isMultipleChoice) {
                const currentAnswers = prevAnswers[qcmId] || [];
                const updatedAnswers = isChecked
                    ? [...currentAnswers, option]
                    : currentAnswers.filter(answer => answer !== option);

                newAnswers = {
                    ...prevAnswers,
                    [qcmId]: updatedAnswers,
                };

                newAnswersRecap = {
                    ...previousAnswersRecap,
                    [qcmId]: {
                        answers: updatedAnswers,
                        index: currentQcmIndex,
                    }
                };
            } else {
                newAnswers = {
                    ...prevAnswers,
                    [qcmId]: isChecked ? [option] : [],
                };

                newAnswersRecap = {
                    ...previousAnswersRecap,
                    [qcmId]: {
                        answers: isChecked ? [option] : [],
                        index: currentQcmIndex,
                    },
                };
            }

            const formattedData = Object.entries(newAnswersRecap).map(([qcmId, data]) => ({
                id: qcmId,
                answers: data.answers,
                index: data.index
            }));

            localStorage.setItem('answers', JSON.stringify(newAnswers));
            localStorage.setItem('answersRecap', JSON.stringify(newAnswersRecap));
            setFormattedAnswers(formattedData);

            console.log("Réponses enregistrées :", formattedData);

            return newAnswers;
        });
    };

    const [accesGroupe, setAccesGroupe] = useState([]);
    const [groupeId, setGroupeId] = useState(null);
    const groupe = localStorage.getItem('groupe');

    const verifGroupe = async () => {
        const groupeStored = localStorage.getItem('groupe');
        const accesGroupeStored = localStorage.getItem('accesGroupe');

        if (groupeStored && accesGroupeStored) {
            setGroupeId(groupeStored);
            setAccesGroupe(JSON.parse(accesGroupeStored));
        } else {
            try {
                const response = await axios.get(`${process.env.REACT_APP_HOTE}/verif-groupe/${user_id}/${groupe}/`);
                if (response.status === 200) {
                    const data = response.data;
                    setGroupeId(data.groupe);

                    let cleanedAccessArray = [];
                    if (Array.isArray(data.acces)) {
                        cleanedAccessArray = data.acces.map((item) =>
                            item.acces
                                ? item.acces.replace(/[\[\]']/g, '').trim().split(',').map((access) => access.trim())
                                : []
                        ).flat();

                        setAccesGroupe(cleanedAccessArray);
                    }

                    localStorage.setItem('groupe', data.groupe);
                    localStorage.setItem('accesGroupe', JSON.stringify(cleanedAccessArray));
                }
            } catch (error) {
                console.error('Erreur lors de la vérification du groupe', error);
            }
        }
    };

    useEffect(() => {
        if (user_id) {
            verifGroupe();
        }
    }, [user_id]);

    if (!accesGroupe.includes("ExamenBlanc")) {
        return (
            <div id="wrapper">
                <Sidebar user_id={user_id} />
                <div id="page-wrapper" className="gray-bg">
                    <Navbar />
                    <div className="wrapper wrapper-content animated fadeInRight">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="ibox">
                                    <div className="ibox-content text-center p-5">
                                        <div className="mb-4">
                                            <i className="fa fa-lock fa-5x text-warning"></i>
                                        </div>
                                        <h2>Accès restreint</h2>
                                        <p className="lead mb-4">
                                            Vous n'avez pas les autorisations nécessaires pour accéder à cette page.
                                        </p>
                                        <div className="d-flex justify-content-center">
                                            <Link to="/" className="btn btn-primary">
                                                <i className="fa fa-arrow-left mr-2"></i>
                                                Retour
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div id="wrapper">
            <Sidebar user_id={user_id} />
            <div id="page-wrapper" className="gray-bg">
                <Navbar />
                <div>
                    <div className="row wrapper border-bottom white-bg page-heading">
                        <div className="col-lg-12">
                            <div className='row justify-content-between'>
                                <div className=' ml-2 row align-items-end'>
                                    <h2>
                                        <FaNewspaper size={25} className='mr-2' />
                                        {isEssai ? 'Essai' : 'Examen blanc'}

                                    </h2>
                                    <span
                                        className="ml-3 toggle-icon"
                                        style={{ cursor: 'pointer', marginBottom: '10px' }}
                                        onClick={() => setShowInfo(!showInfo)}
                                    >
                                        {showInfo ? <FaChevronUp /> : <FaChevronDown />}
                                    </span>
                                </div>
                            </div>
                            <div className={`info-box ${showInfo ? "open" : ""}`}>
                                {langue === 'Fr' ? (
                                    <small>
                                        {/* Pour chaque QCM, une seule réponse est possible. Cochez la bonne réponse. Utilisez les boutons pour une meilleure gestion des QCM. */}
                                        {/* <br /> */}
                                        <b>Légende des icônes : </b>
                                        <FaEye className="ivt-align-menu" /> indique que la question a été déjà vue.
                                        <br />
                                        Le bouton <FaTimesCircle className="ivt-align-menu" /> permet de terminer une simulation.
                                        Le bouton <FaArrowLeft className="ivt-align-menu" /> permet d'aller sur la question précédente.
                                        Le bouton <FaArrowRight className="ivt-align-menu" /> permet d'aller sur la question suivante.
                                    </small>
                                ) : (
                                    <small>
                                        For each MCQ, only one answer is possible. Check the correct answer. Use the buttons for better management of the MCQ.
                                        <br />
                                        <b>Legend of icons: </b>
                                        <FaEye className="ivt-align-menu" /> indicates that the question has already been seen.
                                        <br />
                                        The <FaTimesCircle className="ivt-align-menu" /> button allows you to finish a simulation.
                                        The <FaArrowLeft className="ivt-align-menu" /> button allows you to go to the previous question.
                                        The <FaArrowRight className="ivt-align-menu" /> button allows you to go to the next question.
                                    </small>
                                )}
                            </div>
                            <div className='row ml-3'>
                                <div className={`row timer ${remainingTime <= 600 ? 'text-danger' : ''}`}>
                                    {isEssai ? (
                                        <div>
                                            {/* <span>⏳ Essai </span> */}
                                        </div>
                                    ) : (
                                        <>
                                            {isPaused && pauseRemainingTime !== null ? (
                                                <p>
                                                    ⏳ Pause en cours : {Math.floor(pauseRemainingTime / 60000)} min {Math.ceil((pauseRemainingTime % 60000) / 1000)} sec restantes
                                                </p>
                                            ) : (
                                                <>
                                                    {examEndTime && (
                                                        <span> Fin à : {formatDateTime(examEndTime)} - </span>
                                                    )}
                                                    Temps restant: {formatTime(remainingTime)}
                                                </>
                                            )}
                                        </>
                                    )}
                                </div>
                                {!isEssai && <StatutInternet />}

                            </div>
                            <small id='hbreadcrumb' className='d-flex justify-content-end'>
                                <ol className="breadcrumb custom-breadcrumb">
                                    <li className="breadcrumb-item custom-breadcrumb-item">
                                        <Link to={`/Historique-examen`}> Examens </Link>
                                    </li>
                                    <li className="breadcrumb-item custom-breadcrumb-item">
                                        {examen_id}
                                    </li>
                                </ol>
                            </small>
                        </div>
                    </div>

                    {alert.message && (
                        <div className={`mt-3 alert alert-${alert.type}`}>
                            {alert.message}
                        </div>
                    )}

                    <div className="wrapper wrapper-content animated fadeInRight mt-3">
                        <div className="row d-flex justify-content-center">
                            <div className="col-lg-8 mx-auto">
                                <div className="ibox">
                                    <div className="ibox-title pr-3">
                                        <tr className='d-flex justify-content-between align-items-center'>
                                            <td className='d-flex'>
                                                <div >
                                                    <td className='badge badge-secondary'> {qcms[currentQcmIndex]?.ref} </td>
                                                    <td>
                                                        {qcms[currentQcmIndex]?.deja_vu === "oui" && (
                                                            <i className="ml-1 fa fa-eye" title="Déjà vu"></i>
                                                        )}
                                                    </td>
                                                </div>
                                                <div className="btn-group ml-2" style={{ width: '100px' }} >
                                                    <button
                                                        onClick={handleModifierLangue}
                                                        className={`btn btn-xs ${langue === 'Fr' ? 'btn-success' : ''}`}
                                                        disabled={langue === 'Fr'}
                                                    >
                                                        FR
                                                    </button>
                                                    <button
                                                        onClick={handleModifierLangue}
                                                        className={`btn btn-xs ${langue !== 'Fr' ? 'btn-success' : ''}`}
                                                        disabled={langue === 'Ang'}
                                                    >
                                                        EN
                                                    </button>
                                                </div>
                                            </td>

                                            <td>
                                                {qcms.length > 0
                                                    ? `${currentQcmIndex + 1} ${langue === 'Fr' ? 'sur' : 'sur '} ${qcms.length}`
                                                    : "0 sur 0"}
                                            </td>

                                            <td className='d-flex'>
                                                {accesGroupe.includes("Administration") &&
                                                    <Button className='mr-2' onClick={() => setShowModal(true)}>
                                                        <FaEdit />
                                                        {showModal && currentQcmIndex !== null && (
                                                            <QuestionModal
                                                                show={showModal}
                                                                handleClose={handleCloseModal}
                                                                qcm_ref={qcms[currentQcmIndex]?.unicite}
                                                                user_id={user_id}
                                                                reussite={fetchExamens}
                                                            />
                                                        )}
                                                    </Button>
                                                }

                                                {!isEssai &&
                                                    <button className="btn btn-outline btn-success mr-2"
                                                        onClick={() => navigate('/Recapitulatif-examen', {
                                                            state: { examen_id: examen_id, nbre_heures: nbre_heures, pauseChoice: pauseChoice },
                                                        })}>
                                                        <i className="fa fa-check mr-1"></i>
                                                        <span className="d-none d-sm-inline">
                                                            <small>Recapitulatif</small>
                                                        </span>
                                                    </button>
                                                }


                                                {isLoadingBouton ? (
                                                    <button className="btn btn-success mr-2" disabled>
                                                        <i className="fa fa-spinner fa-spin mr-1"></i>
                                                        <span className="d-none d-sm-inline">
                                                            {langue === 'Fr' ? 'Chargement...' : 'Loading...'}
                                                        </span>
                                                    </button>
                                                ) : (
                                                    <button className="btn btn-success" onClick={() => setShowConfirmationModal(true)}>
                                                        <i className="fa fa-times-circle mr-1"></i>
                                                        <span className="d-none d-sm-inline">
                                                            <small> Terminer l'{isEssai ? 'essai' : 'examen'} </small>
                                                        </span>
                                                    </button>
                                                )}
                                                {/* <button className="btn btn-success ml-2" onClick={togglePause}>
                                                    {isPaused ? "Reprendre" : "Pause"}
                                                </button> */}
                                            </td>

                                        </tr>
                                    </div>
                                    {!isLoading ? (
                                        <div className="ibox-content">
                                            {qcms.length > 0 ? (
                                                <form>
                                                    <input type="hidden" name="qcmidhidden" id="qcmidhidden" value={qcms[currentQcmIndex]?.id} />
                                                    <div className=''>
                                                        <span id="question" style={{ fontSize: '12px' }} dangerouslySetInnerHTML={{ __html: qcms[currentQcmIndex]?.question }}></span>
                                                    </div>


                                                    <div style={{ margin: '10px 10px' }}>
                                                        {Object.keys(qcms[currentQcmIndex])
                                                            .filter(key => key.startsWith('option') && qcms[currentQcmIndex][key] && (qcms[currentQcmIndex][key] !== 'non défini' && qcms[currentQcmIndex][key] !== 'vide')) // Filtrer les options non définies ou nulles
                                                            .map((key, index) => {
                                                                const optionLetter = String.fromCharCode(65 + index); // Convertir l'index en lettre (A, B, C, ...)
                                                                const isMultipleChoice = qcms[currentQcmIndex].reponse.length > 1; // Vérifie si plusieurs réponses

                                                                // Vérifier si cette question a des réponses sauvegardées dans 'answers'
                                                                const currentAnswers = answers[qcms[currentQcmIndex].ref] || [];
                                                                const isOptionChecked = currentAnswers.includes(optionLetter); // Vérifier si cette option est déjà cochée

                                                                return (
                                                                    <div className="checkbox" key={key} style={{ display: 'flex', alignItems: 'center', marginBottom: '10px' }}>
                                                                        <label style={{ margin: 0, fontSize: '12px', cursor: 'pointer' }}>
                                                                            <input
                                                                                type={isMultipleChoice ? "checkbox" : "radio"}
                                                                                name={`qcmitem-${qcms[currentQcmIndex].ref}`}
                                                                                value={optionLetter}
                                                                                className="i-checks choix"
                                                                                style={{ marginRight: '10px', cursor: 'pointer' }}
                                                                                onChange={(e) => handleMultipleAnswerChange(qcms[currentQcmIndex].ref, optionLetter, e.target.checked, currentQcmIndex)}
                                                                                checked={isOptionChecked}
                                                                            />
                                                                            {optionLetter} - <span id={`option${index + 1}`}>{qcms[currentQcmIndex][key]}</span>

                                                                            {feedbackVisible &&
                                                                                selectedAnswer?.qcmId === qcms[currentQcmIndex].ref &&
                                                                                selectedAnswer.value.includes(optionLetter) &&
                                                                                !explanationVisible && (
                                                                                    qcms[currentQcmIndex].reponse.includes(optionLetter) ? (
                                                                                        <i className="fa fa-thumbs-o-up fa-2x ivt-align-menu" style={{ color: 'green', marginLeft: '5px' }} title="Correct"></i>
                                                                                    ) : (
                                                                                        <i className="fa fa-thumbs-o-down fa-2x ivt-align-menu" style={{ color: 'red', marginLeft: '5px' }} title="Incorrect"></i>
                                                                                    )
                                                                                )}

                                                                            {explanationVisible &&
                                                                                qcms[currentQcmIndex].reponse.includes(optionLetter) && (
                                                                                    <i className="fa fa-thumbs-o-up fa-2x ivt-align-menu" style={{ color: 'green', marginLeft: '5px' }} title="Correct Answer"></i>
                                                                                )}
                                                                        </label>
                                                                    </div>

                                                                );
                                                            })}
                                                    </div>

                                                </form>
                                            ) : (
                                                <p>Aucun QCM trouvé pour cet examen.</p>
                                            )}
                                        </div>
                                    ) : (

                                        <div className="mt-3 d-flex justify-content-center align-items-center" style={{ height: '100%', width: '100%' }}>
                                            <span
                                                className="spinner-border spinner-border-lg text-success"
                                                role="status"
                                                aria-hidden="true"
                                                style={{ width: '3rem', height: '3rem' }}
                                            ></span>
                                        </div>
                                    )}
                                    {
                                        !enLigne ? "" : (
                                            <div className="d-flex ibox-footer justify-content-end">

                                                {currentQcmIndex > 0 && !isPaused && (
                                                    <Button
                                                        onClick={handlePreviousQcm}
                                                        className="btn btn-outline btn-success d-flex align-items-center justify-content-center"
                                                        style={{ marginLeft: '10px', gap: '5px' }}
                                                    >
                                                        <FaArrowCircleLeft />
                                                        Précédent
                                                    </Button>
                                                )}
                                                {currentQcmIndex < qcms.length - 1 && !isPaused && (
                                                    <Button
                                                        onClick={handleNextQcm}
                                                        className="btn btn-outline btn-success d-flex align-items-center justify-content-center"
                                                        style={{ marginLeft: '10px', gap: '5px' }}
                                                    >
                                                        Suivant
                                                        <FaArrowCircleRight />
                                                    </Button>
                                                )}
                                            </div>
                                        )
                                    }
                                </div>

                                <Modal show={showPauseModal} onHide={handleClosePauseModal}>
                                    <Modal.Header>
                                        <Modal.Title>{langue === 'Fr' ? "Pause" : "Break"}</Modal.Title>
                                    </Modal.Header>
                                    <Modal.Body>
                                        {langue === 'Fr'
                                            ? "Voulez-vous faire une pause de 10 minutes ?"
                                            : "Do you want to take a 10-minute break?"}
                                    </Modal.Body>
                                    <Modal.Footer>
                                        <Button variant="secondary" onClick={handleClosePauseModal}>
                                            {langue === 'Fr' ? "Non" : "No"}
                                        </Button>
                                        <Button variant="success" onClick={togglePause}>
                                            {langue === 'Fr' ? "Oui" : "Yes"}
                                        </Button>
                                    </Modal.Footer>
                                </Modal>

                                <Modal show={showConfirmationModal} onHide={() => setShowConfirmationModal(false)}>
                                    <Modal.Header>
                                        <Modal.Title>Confirmation</Modal.Title>
                                    </Modal.Header>
                                    <Modal.Body>
                                        Voulez-vous réellement mettre fin à l'{isEssai ? 'essai' : 'examen'}
                                    </Modal.Body>
                                    <Modal.Footer>
                                        <Button variant="secondary" onClick={() => setShowConfirmationModal(false)}>
                                            Annuler
                                        </Button>
                                        <Button variant="success" onClick={handleFinishExamen}>
                                            Terminer
                                        </Button>
                                    </Modal.Footer>
                                </Modal>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Demarrer_examen;